import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as dayjs from 'dayjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { CompassAPICruiseSearchService } from 'src/app/shared/api-compass/compass-api-cruise-search.service';
import { CompassAPIExcursionItineraryService } from 'src/app/shared/api-compass/compass-api-excursion-itinerary.service';
import { CruiseLineSailDate } from 'src/app/shared/models/cruise-line-sail-date.interface';
import { CruiseLine } from 'src/app/shared/models/cruise-line.interface';
import { ExcursionItinerary } from 'src/app/shared/models/excursion-itineraries.interface';
import { Itinerary } from 'src/app/shared/models/itinerary.interface';
import { ResponseMessage } from 'src/app/shared/models/response-message.interface';
import { ItineraryService } from 'src/app/shared/services/itinerary.service';

@Component({
	selector: 'app-travel-board-image-edit',
	templateUrl: './travel-board-image-edit.component.html'
})
export class TravelBoardImageEditComponent implements OnInit {

	public cancel: EventEmitter<any> = new EventEmitter<any>();
	public selectBoard: EventEmitter<any> = new EventEmitter<any>();
	public createBoard: EventEmitter<any> = new EventEmitter<any>();
	//public chooseBoard: EventEmitter<any> = new EventEmitter<any>();

	public productId: string;
	public board: ExcursionItinerary;

	public boardForm: FormGroup;

	public submitDisabled: boolean = true;
	public attemptedSubmit: boolean = false;
	public responseMsg: ResponseMessage;
	public asset: File; 
	public itinerary: Itinerary = null;

	constructor(
		private _compassAPICruiseSearchService: CompassAPICruiseSearchService,
		private _compassAPIExcursionItineraryService: CompassAPIExcursionItineraryService,
		private formBuilder: FormBuilder,
		private _itineraryService: ItineraryService,
		public modalService: BsModalService,
		private modalRef: BsModalRef,
		private router: Router,
	) { }

	ngOnInit(): void {
		// console.log('TravelBoardEditComponent.productId:', this.productId);
		// console.log('TravelBoardEditComponent.board:', this.board);

		this.itinerary = this._itineraryService.getItinerary();
		//console.log('TravelBoardEditComponent.itinerary:', this.itinerary);
		this.initForm(this.board);

		if(this.itinerary && !this.board?.cruiseInformation) {
			const itinerarySailDate = this.itinerary.sailDate,
				isFutureDate = dayjs().diff(dayjs(itinerarySailDate), 'day') <= 0;
				//console.log('isFutureDate:', isFutureDate, itinerarySailDate); 
			
		}
		

	}

	public initForm(data: ExcursionItinerary = null) {
		//console.log('initForm.data:', data);
		if(!data){
			data = {
				//id: '',
				name: '', 
			}
		}

		this.boardForm = this.formBuilder.group({
			id:  [data.id, []],
			asset: [this.asset, []]
		});

	}

	public onUpload($event){
		this.asset = $event.target.files[0]; 
		console.log($event.target.files[0])
	}

	public onSubmit() {
		//console.log('OrderComponent.onSubmit');

		this.submitDisabled = true;

		this.attemptedSubmit = true;

		this.responseMsg = {status: 'Validating Form.'};

		let updatedBoard: ExcursionItinerary = this.board ? JSON.parse(JSON.stringify(this.board)) : {};//clone board

		if(this.productId != undefined && this.productId != null) {
			if(!updatedBoard.products) updatedBoard.products = [];
			let product: any = {productId: this.productId};
			if(this.board?.id) product.excursionItineraryId = this.board.id;//API will auto-add upon creation if NEW board
			updatedBoard.products.push(product);
		}
		//console.log('TravelBoardComponent.updatedBoard:', updatedBoard);

		//return;

		// if(this.board?.id) {
		let formData = new FormData();

		if(this.asset) {
			formData.append('formFile', this.asset);
		}
		this._compassAPIExcursionItineraryService.postProductsAssets(this.board.id, formData)
		.pipe(first())
		.subscribe((res: any) => {
			//console.log('postProductsAssets.res', res);
			if(res.error) {
				this.responseMsg = {error: res.error.title};
				return;
			}

			this.responseMsg = {success: 'Successfully changed image.'};
			setTimeout(() => {
				this.modalRef?.hide();
			}, 300);
			// SEND STATE UPDATE
			// if (redirect) {
			// 	this.routeToUrl(id);
			// } else {
			// 	this.uploaderIds = [];
			// 	this.fileUploaderGroup.resetUploader();
			// 	this._excursionStore.refreshState();
			// 	this.resetForm();
			// }
		});

	}

	public closeModal() {
		this.cancel.emit();
		this.modalRef?.hide();
	}

}
